module.exports = __webpack_public_path__ + "img/resource-example.c2e88835.jpg";